import { STAGE_ACTIONS } from "constants";

export function fetchStagesList(stageIds) {
    return {
        type: STAGE_ACTIONS.FETCH_STAGES_LIST,
        payload: {
            stageIds
        }
    };
}
export function fetchedStagesList(stageList) {
    return {
        type: STAGE_ACTIONS.FETCHED_STAGES_LIST,
        payload: {
            stageList
        }
    };
}
export function failedFetchStagesList(error) {
    return {
        type: STAGE_ACTIONS.FAILED_FETCH_STAGES_LIST,
        error
    };
}
